var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-dialog",
    {
      key: _vm.storeSettingVisible,
      attrs: { width: "700" },
      on: {
        "click:outside": function($event) {
          return _vm.cancelStoreSetting()
        }
      },
      scopedSlots: _vm._u([
        {
          key: "activator",
          fn: function(ref) {
            var on = ref.on
            var attrs = ref.attrs
            return [
              _c(
                "v-btn",
                _vm._g(
                  _vm._b(
                    {
                      attrs: { disabled: _vm.buttonDisabled, text: "" },
                      on: {
                        click: function($event) {
                          return _vm.showStoreSettingData()
                        }
                      }
                    },
                    "v-btn",
                    attrs,
                    false
                  ),
                  on
                ),
                [
                  _c("img", {
                    attrs: {
                      src: require("@/assets/img/ico-setting.png"),
                      alt: ""
                    }
                  })
                ]
              )
            ]
          }
        }
      ]),
      model: {
        value: _vm.storeSettingVisible,
        callback: function($$v) {
          _vm.storeSettingVisible = $$v
        },
        expression: "storeSettingVisible"
      }
    },
    [
      _c(
        "v-card",
        { staticClass: "popup" },
        [
          _c("h3", { staticClass: "page-title-bar" }, [
            _c("i", { staticClass: "ico ico-store" }),
            _vm._v(_vm._s(_vm.$t("Store Setting")) + " ")
          ]),
          _c(
            "div",
            { staticClass: "custom-scrollBox" },
            [
              _vm._l(_vm.storeInputs, function(inputs, idx) {
                return _c(
                  "v-row",
                  { key: idx },
                  _vm._l(inputs, function(input, colIdx) {
                    return _c(
                      "v-col",
                      {
                        key: input.key,
                        staticClass: "pt-2 pb-2",
                        attrs: { cols: _vm.getCols(idx) }
                      },
                      [
                        input.selectable
                          ? _c("v-select", {
                              ref: input.key,
                              refInFor: true,
                              class: _vm.getStoreInputSelectClass(input.name),
                              attrs: {
                                disabled: input.disabled,
                                items: input.options,
                                label: _vm.$t(input.label) + "*",
                                placeholder: _vm.getPlaceholder(input),
                                outlined: "",
                                dense: "",
                                "hide-details": "",
                                clearable: "",
                                attach: ""
                              },
                              on: {
                                change: function($event) {
                                  _vm.setSelectableAreaNames(idx)
                                  _vm.setConditionsforChLbs(input)
                                },
                                keydown: _vm.clearTabindex
                              },
                              model: {
                                value: input.value,
                                callback: function($$v) {
                                  _vm.$set(input, "value", $$v)
                                },
                                expression: "input.value"
                              }
                            })
                          : _c("v-text-field", {
                              class: _vm.getStoreInputTextClass(input.key, idx),
                              attrs: {
                                disabled: input.disabled || _vm.areaAddDisabled,
                                label: _vm.$t(input.label) + "*",
                                placeholder: _vm.getPlaceholder(input),
                                outlined: "",
                                dense: "",
                                "hide-details": "",
                                clearable: ""
                              },
                              on: {
                                keypress: _vm.handleKeyUpspl,
                                keydown: _vm.clearTabindex
                              },
                              scopedSlots: _vm._u(
                                [
                                  _vm.isAreaInput(input.key)
                                    ? {
                                        key: "append",
                                        fn: function() {
                                          return [
                                            _c(
                                              "v-btn",
                                              {
                                                attrs: {
                                                  disabled: _vm.areaAddDisabled,
                                                  text: ""
                                                },
                                                on: {
                                                  click: function($event) {
                                                    return _vm.addAreaValue(
                                                      input.value,
                                                      idx,
                                                      colIdx - 1
                                                    )
                                                  }
                                                }
                                              },
                                              [
                                                _c("img", {
                                                  attrs: {
                                                    src: require("@/assets/img/btn-save.jpg"),
                                                    alt: ""
                                                  }
                                                })
                                              ]
                                            )
                                          ]
                                        },
                                        proxy: true
                                      }
                                    : null
                                ],
                                null,
                                true
                              ),
                              model: {
                                value: input.value,
                                callback: function($$v) {
                                  _vm.$set(input, "value", $$v)
                                },
                                expression: "input.value"
                              }
                            })
                      ],
                      1
                    )
                  }),
                  1
                )
              }),
              _c(
                "v-expansion-panels",
                {
                  staticClass: "advancedSetting",
                  attrs: { flat: "", accordion: "" },
                  model: {
                    value: _vm.advancedSettingVisible,
                    callback: function($$v) {
                      _vm.advancedSettingVisible = $$v
                    },
                    expression: "advancedSettingVisible"
                  }
                },
                [
                  _c(
                    "v-expansion-panel",
                    [
                      _c(
                        "v-expansion-panel-header",
                        { staticClass: "pl-0 pr-0" },
                        [
                          _c("i", { staticClass: "throwline" }),
                          _vm._v(_vm._s(_vm.$t("Show Advanced Setting")))
                        ]
                      ),
                      _c(
                        "v-expansion-panel-content",
                        _vm._l(_vm.advStoreInputs, function(advInputs, idx) {
                          return _c(
                            "v-row",
                            { key: idx },
                            _vm._l(advInputs, function(advInput) {
                              return _c(
                                "v-col",
                                {
                                  key: advInput.name,
                                  staticClass: "pt-1 pb-1",
                                  attrs: { cols: "4" }
                                },
                                [
                                  advInput.selectable
                                    ? _c("v-select", {
                                        class: _vm.getStoreInputSelectClass(
                                          advInput.name
                                        ),
                                        attrs: {
                                          label: _vm.$t(advInput.label),
                                          placeholder: _vm.getPlaceholder(
                                            advInput
                                          ),
                                          items: advInput.options,
                                          outlined: "",
                                          dense: "",
                                          "hide-details": "",
                                          clearable: ""
                                        },
                                        on: { keydown: _vm.clearTabindex },
                                        model: {
                                          value: advInput.value,
                                          callback: function($$v) {
                                            _vm.$set(advInput, "value", $$v)
                                          },
                                          expression: "advInput.value"
                                        }
                                      })
                                    : _c("v-text-field", {
                                        staticClass: "form-input",
                                        attrs: {
                                          min: advInput.min
                                            ? advInput.min
                                            : -100000,
                                          max: advInput.max
                                            ? advInput.max
                                            : 100000,
                                          disabled: advInput.disabled,
                                          label: _vm.$t(advInput.label),
                                          placeholder: _vm.getPlaceholder(
                                            advInput
                                          ),
                                          outlined: "",
                                          dense: "",
                                          "hide-details": "",
                                          type: "number"
                                        },
                                        on: {
                                          keyup: function($event) {
                                            $event.preventDefault()
                                            return _vm.handleKeyUp($event)
                                          }
                                        },
                                        model: {
                                          value: advInput.value,
                                          callback: function($$v) {
                                            _vm.$set(advInput, "value", $$v)
                                          },
                                          expression: "advInput.value"
                                        }
                                      })
                                ],
                                1
                              )
                            }),
                            1
                          )
                        }),
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            2
          ),
          _c(
            "v-card-actions",
            { staticClass: "d-flex justify-center" },
            [
              _c(
                "v-btn",
                {
                  staticClass: "btn",
                  attrs: { text: "", icon: "" },
                  on: { click: _vm.handleSaveBtnClick }
                },
                [_vm._v(_vm._s(_vm.$t("Save")))]
              ),
              _c(
                "v-btn",
                {
                  staticClass: "btn",
                  attrs: { text: "", icon: "" },
                  on: {
                    click: function($event) {
                      return _vm.cancelStoreSetting()
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("Cancel")))]
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }